export enum UserGroup {
  SYS_ADMIN = 'SYS_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER'
}
export interface IUser {
    id?: string;
    name?: string | null;
    surname?: string | null;
    account?: string | null;
    email?: string | null;
    status?: string | null;
    sex?: string | null;
    address?: string | null;
    group?: UserGroup | null;
    dateOfBirth?: string | null;
    note?: string | null;
    subtenants?: string[] | null;
    userSaml?: boolean;
    tempId?: string | null;
    cognitoUserName?: string | null;
}

export class User implements IUser {
    public id?: string;
    public name?: string;
    public surname?: string;
    public account?: string;
    public email?: string;
    public status?: 'active' | 'inactive' | 'ACTIVE' | 'BLOCKED';
    public sex?: string;
    public address?: string;
    public group?: UserGroup;
    public dateOfBirth?: string | null;
    public note?: string;
    public subtenants?: string[];
    public userSaml?: boolean;
    public tempId?: string | null;
    public cognitoUserName?: string | null;

    constructor(fields?: Partial<IUser>) {
            Object.assign(this, fields);
    }
}

export interface IUserDelete {
    email?: string;
}

export interface UserRole {
    email?: string;
    group?: UserGroup
}
